import { Map } from 'lucide-react'
import type { UseCompanyInfoTabReturn } from '@/features/company/types'
import styles from '../../../styles/companyAdd.module.css'
import { SectionCard } from '@/components/ui/SectionCard'
import { CompanyInfoAddressValidationBanner } from './CompanyInfoAddressValidationBanner'

export function CompanyInfoMapSection({
        register,
        canEditInfo,
        mapRef,
        refreshMap,
        addressValidationMessage,
        isMapMessage,
        isValidatingAddress,
}: UseCompanyInfoTabReturn) {
    return (
            <SectionCard
                icon={Map}
                title="Location Map"
                testId="company-info-latlong-map-section"
            >
                <CompanyInfoAddressValidationBanner message={addressValidationMessage} />
                <div className="mb-4 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                    <div className={styles.formGroup}>
                        <label className={styles.formLabel} htmlFor="company-info-latitude-input">
                            Latitude
                        </label>
                        <input
                            id="company-info-latitude-input"
                            type="number"
                            step="any"
                            readOnly={!isMapMessage}
                            data-testid="company-info-latitude-input"
                            {...register('latitude')}
                            className={styles.customFormControl}
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label className={styles.formLabel} htmlFor="company-info-longitude-input">
                            Longitude
                        </label>
                        <input
                            id="company-info-longitude-input"
                            type="number"
                            step="any"
                            readOnly={!isMapMessage}
                            data-testid="company-info-longitude-input"
                            {...register('longitude')}
                            className={styles.customFormControl}
                        />
                    </div>
                    {canEditInfo && (
                        <div className="flex items-end">
                            <button
                                type="button"
                                data-testid="company-info-refresh-map-button"
                                className={styles.btnPrimary}
                                disabled={isValidatingAddress}
                                onClick={refreshMap}
                            >
                                Refresh Map
                            </button>
                        </div>
                    )}
                </div>

                <div
                    data-testid="company-info-physical-address-map-container"
                    style={{ width: "100%", height: "400px", borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0" }}
                >
                    <div ref={mapRef} style={{ width: "100%", height: "100%" }} />
                </div>
            </SectionCard>
    )
}
